import { getStore, setStore, removeStore, clearStore } from '@/units/store'
import appApi from '@/api/app';
const app = {
  state: {
    appInfo: getStore({ name: 'appInfo' }) || '',
    tenant_id: getStore({ name: 'tenant_id' }) || '',
  },
  actions: {
    /*获取APP信息*/
    async GetTenantId({ commit, dispatch }) {
      const result = await appApi.getTenantId();
      commit('SET_TENANT_ID', result.data.tenant_id)
    },
    /*获取APP信息*/
    async GetAppInfo({ commit, dispatch }) {
      const {data} = await appApi.init('');
      commit('SET_APP_INFO', { app: data.app })
    }
  },
  mutations: {
    SET_APP_INFO: (state, { app }) => {
      state.appInfo = app
      setStore({ name: 'appInfo', content: app })
    },
    SET_TENANT_ID: (state, tenant_id) => {
      state.tenant_id = tenant_id;
      setStore({ name: 'tenant_id', content: tenant_id })
    },
  }
}
export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js